const PRODUCTS_KEYS = {
  PRODUCTS: () => ['products'],
  PRODUCTS_PAGINATED: (params = {}) => [...PRODUCTS_KEYS.PRODUCTS(), 'paginated', params],
  PRODUCTS_INFINITE: (params = {}) => [...PRODUCTS_KEYS.PRODUCTS(), 'infinite', params],

  CHILD_PRODUCTS: () => ['child-products'],
  CHILD_PRODUCTS_PAGINATED: (params = {}) => [
    ...PRODUCTS_KEYS.CHILD_PRODUCTS(),
    'paginated',
    params,
  ],
  CHILD_PRODUCTS_INFINITE: (params = {}) => [...PRODUCTS_KEYS.CHILD_PRODUCTS(), 'infinite', params],

  ALL_CHILD_PRODUCTS: () => ['all-child-products'],
  ALL_CHILD_PRODUCTS_PAGINATED: (params = {}) => [
    ...PRODUCTS_KEYS.ALL_CHILD_PRODUCTS(),
    'paginated',
    params,
  ],
  ALL_CHILD_PRODUCTS_INFINITE: (params = {}) => [
    ...PRODUCTS_KEYS.ALL_CHILD_PRODUCTS(),
    'infinite',
    params,
  ],

  PRODUCT_COLORS: () => ['product-colors'],
  PRODUCT_COLORS_PAGINATED: (params = {}) => [
    ...PRODUCTS_KEYS.PRODUCT_COLORS(),
    'paginated',
    params,
  ],
  PRODUCT_COLORS_INFINITE: (params = {}) => [...PRODUCTS_KEYS.PRODUCT_COLORS(), 'infinite', params],

  PRODUCT_SIZES: () => ['product-sizes'],
  PRODUCT_SIZES_PAGINATED: (params = {}) => [...PRODUCTS_KEYS.PRODUCT_SIZES(), 'paginated', params],
  PRODUCT_SIZES_INFINITE: (params = {}) => [...PRODUCTS_KEYS.PRODUCT_SIZES(), 'infinite', params],

  PRODUCT_CATEGORIES: () => ['product-categories'],
  PRODUCT_CATEGORIES_PAGINATED: (params = {}) => [
    ...PRODUCTS_KEYS.PRODUCT_CATEGORIES(),
    'paginated',
    params,
  ],
  PRODUCT_CATEGORIES_INFINITE: (params = {}) => [
    ...PRODUCTS_KEYS.PRODUCT_CATEGORIES(),
    'infinite',
    params,
  ],

  PRODUCT_INVENTORIES: () => ['product-inventories'],
  PRODUCT_INVENTORIES_PAGINATED: (params = {}) => [
    ...PRODUCTS_KEYS.PRODUCT_INVENTORIES(),
    'paginated',
    params,
  ],
  PRODUCT_INVENTORIES_INFINITE: (params = {}) => [
    ...PRODUCTS_KEYS.PRODUCT_INVENTORIES(),
    'infinite',
    params,
  ],

  FAVORITE_PRODUCTS: () => ['favorite-products'],
};

export default PRODUCTS_KEYS;
